// TODO: refactor to a component.
export const NutritionBmi = $timeout => {
  'ngInject';

  var Controller = function() {
    this.bmi = 0;
    this.markers = [0, 18.5, 25, 30, 50];
    this.styles = ['under', 'healthy', 'over', 'obese'];
  };

  Controller.prototype.bmiMarkerPercent = function() {
    var offset,
      prev,
      curr,
      range,
      width = 100 / (this.markers.length - 1);

    for (var i = 1; i < this.markers.length; i++) {
      offset = (i - 1) * width;
      prev = this.markers[i - 1];
      curr = this.markers[i];
      range = curr - prev;

      if (this.bmi <= curr) {
        return (offset + (this.bmi - prev) / range * width).toFixed(1);
      }
    }

    return 100;
  };

  Controller.prototype.bmiClassName = function() {
    var className = '';

    if (this.bmi < this.markers[4]) {
      className = this.styles[3];
    }

    if (this.bmi < this.markers[3]) {
      className = this.styles[2];
    }

    if (this.bmi < this.markers[2]) {
      className = this.styles[1];
    }

    if (this.bmi < this.markers[1]) {
      className = this.styles[0];
    }

    return className;
  };

  return {
    restrict: 'A',
    controller: Controller,
    controllerAs: 'vm',

    template:
      '<div class="nutrition-bmi">' +
      '  <div class="pop-over">' +
      '    Your BMI: {{ vm.bmi }}' +
      '    <div class="pop-over-arrow"></div>' +
      '  </div>' +
      '  <ul class="description">' +
      '    <li class="under">Underweight</li>' +
      '    <li class="healthy">Healthy</li>' +
      '    <li class="over">Overweight</li>' +
      '    <li class="obese">Obese</li>' +
      '  </ul>' +
      '  <ul class="value">' +
      '    <li class="low">18.5 BMI</li>' +
      '    <li class="medium">25 BMI</li>' +
      '    <li class="high">30 BMI</li>' +
      '  </ul>' +
      '</div>',

    scope: {
      bmi: '=nutritionBmi',
    },

    link: function(scope, element, attrs, controller) {
      var deregWatch = scope.$watch('bmi', function(value) {
        if (value) {
          $timeout(function() {
            var pop_over = element.find('.pop-over'),
              offset = pop_over.outerWidth() / element.outerWidth() * 100 / 2;

            controller.bmi = value;

            pop_over
              .css('margin-left', controller.bmiMarkerPercent() - offset + '%')
              .addClass(controller.bmiClassName());

            deregWatch();
          });
        }
      });
    },
  };
};



// WEBPACK FOOTER //
// ./src/components/Nutrition/NutritionBmi.js